import React from "react";
import { deleteAllCookies } from "../Helpers/Utils";

const Unauthorized = () => {
    const backToLogin = () => {
        deleteAllCookies();
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace("/login");
    };
    return (
        <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
            <div className="text-center p-4">
                <i className="fa-solid fa-lock fs-1 text-danger mb-3"></i>
                <h3 className="fw-bold mb-2">Session Expired</h3>
                <p className="text-muted mb-4">Your session has expired or you're not authorized to access this page.<br />Please log in again to continue.</p>
                <button className="btn btn-theme px-4" onClick={backToLogin}>Back to Login</button>
            </div>
        </div>
    );
};

export default Unauthorized;
